import React from 'react';
import SEO from './SEO';
import EvidenceBanner from './EvidenceBanner';
import EvidenceInfoSection from './EvidenceInfoSection';
import LogoSlider from './LogoSlider';
import EvidenceServicesSection from './EvidenceServicesSection';
import EvidencePeopleFirstSection from './EvidencePeopleFirstSection';

const EvidencePage = () => {
  return (
    <div>
      <SEO
        title="Evidence – Lloyd James Media"
        description="Discover our evidence-based approach to data solutions. Proven methodologies and trusted partnerships delivering measurable results for your business."
        keywords="evidence-based data, data solutions, proven methodologies, data partnerships, business results, Lloyd James"
        canonical="/evidence"
      />
      {/* Banner Section */}
      <EvidenceBanner />
      
      {/* Pink Info Section */}
      <EvidenceInfoSection />
      
      {/* Logo Slider Section */}
      <LogoSlider />
      
      {/* Services Section */}
      <EvidenceServicesSection />
      
      {/* Putting People First Section (includes Simple Banner) */}
      <EvidencePeopleFirstSection />
    </div>
  );
};

export default EvidencePage;